<script lang="ts">
    import Card from '@smui/card';
    import Select, { Option } from '@smui/select';
    import Input from '@smui/textfield';
    import { _ } from 'svelte-i18n';
    import StepWizard from 'svelte-step-wizard';
    import { writable } from 'svelte/store';
    import FieldLoading from '../../../../../../shared/components/common/Loading/FieldLoading.svelte';
    import FormLoading from '../../../../../../shared/components/common/Loading/FormLoading.svelte';
    import ConfirmModal from '../../../../../../shared/components/common/Modal/ConfirmModal.svelte';
    import TitleCard from '../../../../../../shared/components/common/Title.svelte';
    import PSCLElaborazione from '../../../../../../shared/models/PSCL/Elaborazione/PSCLElaborazione';
    import CategoriaMisuraPunteggioPosizione from '../../../../../../shared/models/PSCL/Misura/CategoriaMisuraPunteggioPosizione';
    import Questionario from '../../../../../../shared/models/Questionario/Questionario';
    import Sede from '../../../../../../shared/models/Sede/Sede';
	import SedeCheckResult from '../../../../../../shared/models/Sede/SedeCheckResult';
    import { userSession } from '../../../../../../shared/stores';
    import PSCLCategoria from './PSCLCategoria.svelte';
    import Svelecte from 'svelecte';

    export let params = { id: '0' };

    let [data, loading, error] = PSCLElaborazione.get(params.id);
    let [dataSubmit, loadingSubmit, errorSubmit] = [null, null, null];
    let [dataSedi, loadingSedi, errorSedi] = Sede.getList({ areaId: $userSession?.areaId, aziendaEnteId: $userSession?.aziendaEnteId });
    let [dataQuestionari, loadingQuestionari, errorQuestionari] = Questionario.getList({
        areaId: $userSession?.areaId,
        aziendaEnteId: $userSession?.aziendaEnteId,
        visibileAdAziendaEnte: true,
    });
	let [dataCheckSedi, loadingCheckSedi, errorCheckSedi] = [writable([]), writable(false), writable(null)];

    let sedeCheckResults: SedeCheckResult[] = [];

    $: if ($data && $data.id !== 0 && $data.sede && (!$data.sedi || $data.sedi.length === 0)) {
        $data.sedi = [$data.sede];
    }

    $: if ($data.sedi) {
        if ($data.sedi.length > 0) {
            [dataCheckSedi, loadingCheckSedi, errorCheckSedi] = CategoriaMisuraPunteggioPosizione.checkSedi($data.sedi);
        } else {
            dataCheckSedi.set([]);
            loadingCheckSedi.set(false);
            errorCheckSedi.set(null);
        }
    }

    let selectedQuestionario: Questionario | undefined = undefined;
    $: selectedQuestionario = $data.questionario;

    let openConfirmSubmitDialog: boolean = false;

    function onSubmit() {
        if ($dataCheckSedi && $dataCheckSedi.some(result => !result.isValid)) {
			alert("Non è possibile salvare. Alcune sedi non sono valide.");
			return;
		}

        $data.questionario = null;

        $data.psclCategorie.forEach((psclCategoria) => {
            psclCategoria.psclMisure.forEach((psclMisura) => {
                psclMisura.asse = null;
                psclMisura.tipoMisura = null;
                psclMisura.costoGestione = isNaN(psclMisura.costoGestione) ? 0 : psclMisura.costoGestione;
                psclMisura.costoImplementazione = isNaN(psclMisura.costoImplementazione) ? 0 : psclMisura.costoImplementazione;

                psclMisura.psclMisuraAzioneComunicazione.forEach((azioneComunicazione) => {
                    azioneComunicazione.costo = isNaN(azioneComunicazione.costo) ? 0 : azioneComunicazione.costo;
                });

                psclMisura.psclMisuraAzioneMonitoraggio.forEach((azioneMonitoraggio) => {
                    azioneMonitoraggio.costo = isNaN(azioneMonitoraggio.costo) ? 0 : azioneMonitoraggio.costo;
                });
            });
        });

        [dataSubmit, loadingSubmit, errorSubmit] = PSCLElaborazione.save($data);
    }

    $: {
        if ($dataSubmit) {
            let responseArray;
            if (Array.isArray($dataSubmit)) {
                responseArray = $dataSubmit;
            } else if (
                $dataSubmit &&
                typeof $dataSubmit === 'object' &&
                'length' in $dataSubmit &&
                typeof $dataSubmit.length === 'number'
            ) {
                responseArray = Array.from($dataSubmit);
            } else {
                responseArray = [$dataSubmit];
            }

            if (responseArray.length === 1) {
                const newId = responseArray[0].id;
                if (newId && newId !== 0) {
                    window.location.hash = `/psclelaborazione/${newId}`;
                    [data, loading, error] = PSCLElaborazione.get(newId);
                }
            } else if (responseArray.length > 1) {
                window.location.hash = `/psclelaborazioni`;
            }
        }
    }



</script>

<ConfirmModal 
    content="<p class='font-bold'>Sei sicuro di voler completare l'operazione?</p>
            <p class='text-sm'>Confermando, procederai con il salvataggio completo dell'elaborazione, assicurati di aver implementato tutte le misure previste</span>.</p>"
    bind:showModal="{openConfirmSubmitDialog}" 
    onConfirm="{() => onSubmit()}" 
/>
<Card class="md:px-8 md:py-8" padded>
    <div class="flex justify-between">
        <TitleCard title="{$_('page.pscl.detail.title')}" />
    </div>
    {#if $loading}
        <FormLoading customClass="pt-8" />
    {:else}
        <StepWizard initialStep="{1}">
            <StepWizard.Step num="{1}" let:nextStep>
                <div class="grid grid-cols-1 px-4 pt-4">
                    <div class="flex col-start-2" style="text-align: end">
                        <button
							disabled="{$data?.sedi?.length === 0 || $data.questionarioId == 0 || !$data.descrizione || ($dataCheckSedi && $dataCheckSedi.some(result => !result.isValid))}"
							type="button"
							class="btn-white h-14 w-14 sm:h-16 sm:w-16"
							on:click="{nextStep}"
						>
							<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_forward_ios</span>
						</button>
                    </div>
                </div>
                <span class="p-4">
                    Compila i dati generali dell'elaborazione, seleziona almeno una sede e un questionario per proseguire.
                </span>
                <div class="md:grid-cols-3 grid grid-cols-1">
                    <Input label="{$_('page.pscl.detail.processing_name')}" bind:value="{$data.descrizione}" class="md:col-start-2" required />
                    {#if $loadingSedi}
                        <FieldLoading customClass="md:col-start-2" />
                    {:else}
                        <Svelecte
                            options="{$dataSedi.response}"
                            labelField="denominazione"
                            valueField="id"
                            valueAsObject={true}
                            placeholder="{$_('page.pscl.detail.location')}"
                            bind:value={$data.sedi}
                            multiple={true}
                            disabled={$data.id !== 0}
                            class="md:col-start-2 pt-2"
                            required
                        />
                        {#if $dataCheckSedi && $dataCheckSedi.length > 0}
							<div class="sede-check-results md:col-start-2">
								{#each $dataCheckSedi as result}
                                    <div class="text-xs mb-1.5" class:text-red-600={!result.isValid}>
                                        {result.isValid ? `✅ I dati della sede ${result.sedeDenominazione ?? ''} sono stati caricati correttamente` : `❌ Sede ${result.sedeDenominazione ?? ''}: ${result.message}`}
                                    </div>                              
								{/each}
							</div>
						{/if}
                    {/if}
                    {#if $loadingQuestionari}
                        <FieldLoading customClass="md:col-start-2" />
                    {:else}
                        <Select
                            label="{$_('page.pscl.detail.survey')}"
                            key="{(questionario) => `${(questionario && questionario?.id) || ''}`}"
                            class="md:col-start-2 w-full"
                            bind:value="{selectedQuestionario}"
                            required
                        >
                            {#if $dataQuestionari.response}
                                {#each $dataQuestionari.response as questionario (questionario?.id)}
                                    {#if questionario?.descrizione}
                                        <Option
                                            value="{questionario}"
                                            on:click="{() => {
                                                $data.questionario = questionario;
                                                $data.questionarioId = questionario.id;
                                            }}">{questionario.descrizione}</Option
                                        >
                                    {/if}
                                {/each}
                            {/if}
                        </Select>
                    {/if}
                </div>
            </StepWizard.Step>
            <StepWizard.Step num="{2}" let:previousStep let:nextStep>
                <div class="grid grid-cols-2 px-4 pt-4">
                    <div class="justify-self-start col-start-1">
                        <button type="button" disabled={$data.id == 0} class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{previousStep}">
                            <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">arrow_back_ios</span>
                        </button>
                    </div>
                    <div class="justify-self-end col-start-2">
                        <button
                            type="button"
                            class="btn-white h-14 w-14 sm:h-16 sm:w-16"
                            on:click="{() => openConfirmSubmitDialog = true}"
                        >
                            <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
                        </button>
                    </div>
                </div>
                <span class="p-4">{$_('page.pscl.detail.creation_info')}</span>
                <div class="font-bold text-center text-red-600">
                    ATTENZIONE: Salvare prima di uscire
                </div>
                <PSCLCategoria bind:data="{$data.psclCategorie}" bind:sedi="{$data.sedi}" />
            </StepWizard.Step>
        </StepWizard>
    {/if}
</Card>

<style>
    .sede-check-results {
        margin-top: 10px;
    }
    .sede-check-result {
        margin-bottom: 5px;
    }
    .sede-check-result.invalid {
        color: red;
    }
</style>
